import React, { useEffect, useState } from "react"
import {
    Sidebar,
    SidebarContent,
    SidebarFooter,
    SidebarGroup,
    SidebarHeader,
    SidebarMenu,
    SidebarMenuItem,
    SidebarMenuButton,
    SidebarGroupLabel,
    SidebarGroupContent,
    useSidebar
} from "../../../components/ui/sidebar";

import {
    Menu,
    ChevronRight,
    ChevronDown,
    ChevronUp,
    Briefcase,
    Plus,
    BellIcon,
    User2,
    LogOut
} from "lucide-react"

import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger, DropdownMenuLabel, DropdownMenuSeparator } from "../../../components/ui/dropdown-menu"
import { NavConfig } from "./NavConfig";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { cn } from "../../../lib/utils"
import { Popover, PopoverContent, PopoverTrigger } from "../../../components/ui/popover"
import { RegistrationStatus } from "../../../Utilities/enums";
import { useAuthentication } from "./../../../Authentication/useAuthentication";
// @ts-ignore
import { useTenantManagement } from "../../Services/TenantManagement.tsx";
import CompanyRegistration from "../CompanyProfile/CompanyProfile";
// @ts-ignore
import { useUserContext } from "../../../Contexts/UserProvider.tsx";
// @ts-ignore
import { useGlobalUsers } from "../../Services/UserManagement.tsx";
import {
    Avatar,
    AvatarFallback,
    AvatarImage,
} from "../../../components/ui/avatar";
import ConfirmDialog from "../Modals/ConfirmationModal";
import { useUIContext } from "../../../Contexts/UIProvider";

const AppSideBar = (props) => {
    const [expandedNav, setExpandedNav] = useState(true);
    const [teamsOpen, setTeamsOpen] = useState(false)
    const [tenants, setTenants] = useState([]);
    const [selectedTenant, setSelectedTenant] = useState(null);
    const [isShow, setIsShow] = useState(false);
    const [selectedNavItem, setSelectedNavItem] = useState(null);
    const { id } = useParams();
    const location = useLocation();
    const { state } = useSidebar();

    const { user, userInfo, tenant, setTenant, setUser, setUserInfo } = useUserContext();
    const { setRouteDto, accountDashboardVersion, notifyAccountDashboardRefresh } = useUIContext();
    const { profileEdit, logout } = useAuthentication();
    const { getTenantsForUsers, getTenantDetail } = useTenantManagement();
    const { searchUsers } = useGlobalUsers();
    const navigate = useNavigate();
    const [isDropdownOpen, setIsDropdownOpen] = useState(null);
    const pathParts = location.pathname;

    const [confirmationModal, setConfirmationModal] = useState({
        isShow: false,
        onConfirm: () => { },
    });

    useEffect(() => {
        console.log("tenant in sidebar : ", tenant);
    }, [tenant]);

    useEffect(() => {
        getTenants();
    }, []);

    useEffect(() => {
        if (accountDashboardVersion > 0 && user?.email) {
            getTenants();
        }
    }, [accountDashboardVersion, user?.email]);

    useEffect(() => {
        if (!id) {
            props?.setIsContentLoad(true);
            return;
        }
        // Keep the selected tenant code in sync with the route so API headers use it.
        if (user?.tenant !== id) {
            setUser({ tenant: id });
        }
    }, [id]);

    useEffect(() => {
        if (id) {
            getTenants();
            getUserDetails();
        }
    }, [id, user?.email]);

    useEffect(() => {
        if (id) {
            getTenantDetails();
        }
    }, [id, user?.tenant]);

    useEffect(() => {
        if (id) {
            getTenantDetails();
        }
    }, [pathParts]);

    useEffect(() => {
        const pathParts = location.pathname.split("/");
        const params = new URLSearchParams(window.location.search);
        const type = decodeURIComponent(params.get("type") || null);
        const navPath = pathParts[pathParts.length - 1];
        if (type && type !== "null") {
            const navPath = pathParts[pathParts.length - 2];
            const filteredNavPath = NavConfig.secureTenantRoutes.filter((item) => item.navPath === navPath);
            setSelectedNavItem(filteredNavPath[0]);
            setRouteDto(filteredNavPath[0]);
            return;
        }

        const filteredNavPath = NavConfig.secureTenantRoutes.filter((item) => item.navPath === navPath);
        setSelectedNavItem(filteredNavPath[0]);
        setRouteDto(filteredNavPath[0]);

    }, [location]);

    const getTenants = async () => {
        if (user?.email) {
            getTenantsForUsers()
                .then((res) => {
                    const mappedList = res
                        .filter((tenant) => tenant.registrationStatus === RegistrationStatus.Approved)
                        .map((tenant) => ({
                            ...tenant,
                            registrationStatus: RegistrationStatus[tenant.registrationStatus],
                        }));

                    setTenants(mappedList);
                })
                .catch((error) => {
                    setTenants([]);
                    console.log("Tenant Error : ", error);
                });
        }
    };

    const getTenantDetails = async () => {
        if (user?.email && id) {
            const tenantDetails = await getTenantDetail();
            setTenant(tenantDetails);
            setSelectedTenant({...tenantDetails, registrationStatus : RegistrationStatus[tenantDetails.registrationStatus]});
            props?.setIsContentLoad(true);
        }
    };

    const getUserDetails = async () => {
        if (user?.email && id) {
            const userDetails = await searchUsers(user?.email);
            setUserInfo(userDetails);
        }
    };

    const handleShiftTenant = async (tenant) => {
        props?.setIsContentLoad(false);
        setUser({ tenant: tenant?.code });
        setRouteDto(NavConfig.secureTenantRoutes[1]);
        navigate(`/app/${tenant?.code}/dashboard`);
        window.location.reload();
    };

    const handleNavItemClick = (item) => {
        setSelectedNavItem(item);
        setRouteDto(item);
        console.log(item);
    };

    const handleConfirmationModal = (isOpen, onConfirm) => {
        setConfirmationModal({
            isShow: isOpen,
            onConfirm: onConfirm,
        });
    };

    return (
        <div>
            <Sidebar collapsible="icon" className="border-none">
                <Popover open={teamsOpen} onOpenChange={setTeamsOpen}>
                    <SidebarHeader className="border-sidebar-border px-4 py-4">
                        {state === 'expanded' && (
                            <PopoverTrigger asChild>
                                <button className="group flex items-center justify-between w-full hover:bg-sidebar-accent/20 rounded-md p-2 -m-2">
                                    <div className="flex items-center gap-2">
                                        <Avatar className="h-10 w-10 flex-shrink-0">
                                            <AvatarImage
                                                src={selectedTenant?.logo || `../../../Assets/placeholder.svg`}
                                                alt={selectedTenant?.name}
                                            />
                                            <AvatarFallback className="text-sidebar-foreground text-sm">
                                                {selectedTenant?.avatar}
                                            </AvatarFallback>
                                        </Avatar>
                                        <div>
                                            <div className="font-semibold text-xl text-sidebar-foreground">
                                                {selectedTenant?.name || "Elystrion"}
                                            </div>
                                            <div className="text-xs text-sidebar-foreground text-left">
                                                Enterprise
                                            </div>
                                        </div>
                                    </div>
                                    <ChevronDown className="w-4 h-4" />
                                </button>

                            </PopoverTrigger>
                        )}
                    </SidebarHeader>

                    <PopoverContent className="w-64 p-0 bg-muted-primary text-sidebar-foreground">
                        <div className="p-2">
                            <div className="px-2 py-1.5 text-xs font-semibold text-sidebar-foreground/70 uppercase tracking-wide">
                                Organizations
                            </div>
                            <div className="mt-2 space-y-1">
                                {tenants.map((item) => (
                                    <button
                                        key={item?.id}
                                        className="w-full flex items-center justify-between px-2 py-2 rounded-md text-sm hover:bg-sidebar-accent transition-colors"
                                        onClick={() => {
                                            handleShiftTenant(item);
                                            setSelectedTenant(item)
                                        }}
                                    >
                                        <div className="flex items-center gap-2 flex-1">
                                            <span>{item?.name}</span>
                                        </div>
                                    </button>
                                ))}

                            </div>
                            <button
                                className="w-full flex items-center gap-2 px-2 py-2 mt-2 text-sm text-gray rounded-md transition-colors pt-3"
                                onClick={() => {
                                    setIsDropdownOpen(false);
                                    setIsShow(!isShow);
                                }}
                            >
                                <Plus className="w-4 h-4" />
                                <span>Register Organization</span>
                            </button>
                        </div>
                    </PopoverContent>
                </Popover>

                <SidebarContent>
                    <SidebarGroup>
                        <SidebarGroupLabel className="text-sm">Tabs</SidebarGroupLabel>
                        <SidebarGroupContent>
                            <SidebarMenu>
                                {NavConfig[props?.route]
                                    ?.filter(item => !item.permission || user?.permissions?.includes(item.permission))
                                    ?.map((item, index) =>
                                (
                                    <Link
                                        key={index}
                                        onClick={() => {
                                            handleNavItemClick(item)
                                        }}
                                        to={item?.navPath}
                                    >
                                        <SidebarMenuItem
                                            key={index}
                                            className={`dark-menu-item jh-12 py-2 hover:bg-[#252525] ${item?.index === selectedNavItem?.index && "bg-[#252525] dark-menu-item-selected"}`}>
                                            <SidebarMenuButton asChild>
                                                <div>
                                                    {item?.Icon}
                                                    <span className="text-base">{item.navItem}</span>
                                                </div>
                                            </SidebarMenuButton>
                                        </SidebarMenuItem>
                                    </Link>
                                )
                                )}
                            </SidebarMenu>
                        </SidebarGroupContent>
                    </SidebarGroup>
                    <SidebarGroup />
                </SidebarContent>
                <SidebarFooter>
                    <SidebarMenu>
                        <SidebarMenuItem>
                            <DropdownMenu>
                                <DropdownMenuTrigger asChild>
                                    <SidebarMenuButton>
                                        <User2 /> {userInfo?.firstName}
                                        <ChevronUp className="ml-auto" />
                                    </SidebarMenuButton>
                                </DropdownMenuTrigger>
                                <DropdownMenuContent
                                    side="top"
                                    className="w-[--radix-popper-anchor-width]"
                                >
                                    {/* <DropdownMenuItem onClick={() => profileEdit()}>
                                        <span>Profile</span>
                                    </DropdownMenuItem> */}
                                    {/* <DropdownMenuItem>
                                        <span>Billing</span>
                                    </DropdownMenuItem> */}
                                    <DropdownMenuItem onClick={() => handleConfirmationModal(true, () => logout())}>
                                        <span>Sign out</span>
                                    </DropdownMenuItem>
                                </DropdownMenuContent>
                            </DropdownMenu>
                        </SidebarMenuItem>
                    </SidebarMenu>
                </SidebarFooter>
            </Sidebar>
            <CompanyRegistration
                open={isShow}
                onOpenChange={setIsShow}
                setIsContentLoad={props?.setIsContentLoad}
                setIsShow={setIsShow}
                setIsDialogOpen={() => { }}
                setIsRegisterTenant={() => { }}
                onSuccessCallBack={notifyAccountDashboardRefresh}
            ></CompanyRegistration>

            <ConfirmDialog isShow={confirmationModal?.isShow} setIsDialogOpen={setConfirmationModal} title="Are you sure you want to log out? " description="" confirmText="Logout" cancelText="Cancel" onConfirm={confirmationModal?.onConfirm} />
        </div>
    )
}

export default AppSideBar;